export default __webpack_public_path__ + "static/media/30.ad86f4d2.jpg";